import { Homepage } from '@/admin/components';

export const HomepagePage = () => <Homepage />;
